module.exports = __webpack_public_path__ + "img/ten.9d392e1a.png";